module.exports = __webpack_public_path__ + "static/media/location.a3c09d96.svg";